import type { HelpFile } from '../../types/help'
import { EmailConfigCardTestIds } from '../../../testids/EmailConfigCardTestIds'

export const emailConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [EmailConfigCardTestIds.emailConfigCard]:
      'Email connector configuration — how this connector composes and sends emails to the target system.',
    [EmailConfigCardTestIds.cardTitleEmailConfig]: null,
    [EmailConfigCardTestIds.emailNotConfigured]:
      'No email configuration set — this connector cannot send messages without it.',
    [EmailConfigCardTestIds.btnCreateEmailConfig]: null,
    [EmailConfigCardTestIds.btnEditEmailConfig]: null,
    [EmailConfigCardTestIds.selectBodyContentType]:
      'Choose whether outgoing messages are sent as plain text or HTML.',
  },
}
